export enum InnerRestrictionTypeEnum {
    FORBID, ALLOW,
}
